import React from 'react'
import {Layout} from 'antd'
import SiderNav from '../../components/SiderNav'
import ContentMain from '../../components/ContentMain'
import HeaderBar from '../../components/HeaderBar'
import {isStringEmpty} from "../../utils/utils";
import * as HttpUtils from "../../components/DoFetch/doFetch";

const {Sider, Header, Content, Footer} = Layout


class Index extends React.Component{
  state = {
    collapsed: false,
    fetchHasRechargeId: "",
  }

  componentDidMount() {
    this.loopFetchHasRecharge();
  }

  loopFetchHasRecharge(){
    if (!isStringEmpty(this.state.fetchHasRechargeId)){
      clearInterval(this.state.fetchHasRechargeId)
    }

    let that=this
    let intervalId = setInterval(function (){
      console.log("loop fetch has recharge...")

      let url = "/boss/rechargerecord/fetchHasRecharge";
      let success = (res) => {
        that.playRechargeMusic(res);
        that.playAuthMusic(res);
      };
      let failBack = (res) => {

      };
      HttpUtils.doGet(this, url, success, failBack);

    }, 5000)
    this.setState({
      fetchHasRechargeId: intervalId,
    })
  }

  playRechargeMusic = (res) => {
    let result = res.data.hasRecharge;
    if (isStringEmpty(result) || 0 == result){
      return;
    }
    var mp3Url = require('../../assets/rechargeRmind.mp3');
    var player = new Audio(mp3Url);
    player.play(); //播放 mp3这个音频对象
  }

  playAuthMusic = (res) => {
    let result = res.data.hasAuth;
    if (isStringEmpty(result) || 0 == result){
      return;
    }
    var mp3Url = require('../../assets/authRemind.mp3');
    var player = new Audio(mp3Url);
    player.play(); //播放 mp3这个音频对象
  }

  toggle = () => {
    // console.log(this)  状态提升后，到底是谁调用的它
    this.setState({
      collapsed: !this.state.collapsed
    })
  }
  render() {
    // 设置Sider的minHeight可以使左右自适应对齐
    return (
      <div id='page'>
        <Layout >
          <Sider collapsible
                 trigger={null}
                 collapsed={this.state.collapsed}
          >
            <SiderNav/>
          </Sider>
          <Layout >
            <Header style={{background: '#fff', width: '100%'}}>
              <HeaderBar collapsed={this.state.collapsed} onToggle={this.toggle}/>
            </Header>
            <Content  style={{display:'flex',position: 'relative',flexDirection:'column',flex:1}}>
              <ContentMain/>
            </Content>
          </Layout>
        </Layout>
      </div>
    );
  }
}
export default Index


// WEBPACK FOOTER //
// ./src/routes/Index/index.js